import React, { Component } from 'react';
import { Spin, DatePicker, Select, Button, message } from 'antd';
import HighChartsCom from './HighChartsCom';
import SelectProvince from '../../common/SelectProvince';
import chartConfig from '../../common/chartsConfig';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class OutPut extends Component {
    state = {
        series: [],
        categories: [],
        searchParams: {
            areaName: '全国',
            hasCheckedArea: ['COUNTRY_0'],
            areaParams: { 'params[全国]': 'COUNTRY_0' },
            statisticsType: ['investigation', 'total'],
            startDate: moment().subtract(11, 'M').format(monthFormat),
            endDate: moment().format(monthFormat),
        },
        loading: false,
        chartsConfig: {}
    }

    componentDidMount() {
        this.loadData();
        const chartsConfig = JSON.parse(JSON.stringify(chartConfig));
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'label'
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
                const { searchParams } = this.state;
                const { areaParams, statisticsType, startDate, endDate } = searchParams;
                if (Object.keys(areaParams).length == 0) {
                    message.error('请选择区域');
                    return;
                }

                const params = {
                    ...searchParams,
                    ...areaParams,
                    areaParams: '',
                    hasCheckedArea: '',
                    begin: startDate,
                    end: endDate,
                    statisticsType: statisticsType.join(','),
                };
                ExportUtil.export({ ...params }, null, API_URL.home.exportAreaProduct);
            },
            text: '导出Excel'
        }
        this.setState({ chartsConfig });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { searchParams } = this.state;
        const { areaParams, statisticsType } = searchParams;

        const params = {
            ...searchParams,
            ...areaParams,
            areaParams: '',
            hasCheckedArea: '',
            statisticsType: statisticsType.join(','),
        };

        const options = {
            method: 'POST',
            url: API_URL.home.queryOutputRateStatistics,
            data: {
                ...params,
            },
            dateType: 'json',
            doneResult: res => {
                const { datas, names, monthList } = res;

                const categories = monthList;
                const series = names.map((d, i) => ({
                    name: names[i],
                    data: datas[i].map(d => (d.consumeFte / d.employeeCount) * 100)
                }))

                this.setState({
                    series,
                    categories,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        const { startDate, endDate } = searchParams;
        if (key === 'startDate') {
            if (moment(dateString).valueOf() > moment(endDate).valueOf()) {
                message.warning('开始时间不能大于结束时间！');
                return;
            }
        } else if (key === 'endDate') {
            if (moment(dateString).valueOf() < moment(startDate).valueOf()) {
                message.warning('结束时间不能小于开始时间！');
                return;
            }
        }
        searchParams[key] = dateString;
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState(state => ({
            searchParams: {
                ...state.searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        }))
    }

    disabledDate = (current) => {
        const { searchParams } = this.state;
        const { startDate } = searchParams;
        const value = moment(startDate).add(11, 'M').valueOf();
        return current && current.valueOf() > value;
    }

    render() {
        const { series, categories, loading, searchParams } = this.state;
        const { areaName, hasCheckedArea, statisticsType, startDate, endDate } = searchParams;
        return (
            <div className="flexItem outer myFocus" style={{ minHeight: 500 }}>
                <Spin spinning={loading}>
                    <div className='modTitle'>人员产出率</div>
                    <div className='tit'>近期人员产出率</div>
                    <div style={{ marginBottom: 30 }}>
                        <Select
                            style={{ width: 144, verticalAlign: 'bottom' }}
                            onChange={value => this.handleSelectChange(value, 'statisticsType')}
                            value={statisticsType}
                            placeholder='请选择'
                            className="multiple-stage"
                            filterOption={false}
                            mode="multiple"
                        >
                            <Option value="investigation">临床部项目产出率</Option>
                            <Option value="total">临床部总产出率</Option>
                        </Select >
                        <span className="ant-divider" style={{ margin: '0 4px' }} />
                        <SelectProvince style={{ width: 120, verticalAlign: 'middle' }} areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                        <span className="ant-divider" style={{ margin: '0 4x' }} />
                        <MonthPicker
                            placeholder="请选择"
                            style={{ width: 80, verticalAlign: 'middle' }}
                            format={monthFormat}
                            value={moment(startDate)}
                            allowClear={false}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'startDate')}
                        />
                        <span className="ant-divider" style={{ margin: '0 4px' }} />
                        <MonthPicker
                            placeholder="请选择"
                            style={{ width: 80, marginRight: 10, verticalAlign: 'middle' }}
                            format={monthFormat}
                            value={moment(endDate)}
                            allowClear={false}
                            disabledDate={this.disabledDate}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endDate')}
                        />
                        <Button type='primary' onClick={this.loadData} style={{verticalAlign: 'middle'}}>统计</Button>
                    </div>
                    <div style={{ marginTop: 20 }}><HighChartsCom series={series} categories={categories} chartsConfig={this.state.chartsConfig} /></div>
                </Spin>
            </div>
        );
    }
}

export default OutPut;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/OutPut.js